import { SPEECH_SERVER_URI } from '../../constants';

// Messaging interface between client / server. I.e. keys in messages.
const SESSION_ID = 'SESSION_ID';
const COMMAND = "COMMAND";
const STATUS = 'STATUS';
const DATA = 'DATA';
const ERROR = 'ERROR';
const LANGUAGES = 'LANGUAGES';
const ACCESS_TOKEN = 'ACCESS_TOKEN';

// COMMANDS sent by the client to start / restart the google speech processing
const START = 'START';
const STOP = 'STOP';
const RESTART = 'RESTART';

// STATUS sent by the server to the client
const STARTED = 'STARTED';
const STOPPED = 'STOPPED';

// Format payload before sending and make sure ws is ready before sending
function send(ws, payload) {
  payload[SESSION_ID] = payload[SESSION_ID] || null;
  payload[COMMAND] = payload[COMMAND] || null;
  payload[STATUS] = payload[STATUS] || null;
  payload[DATA] = payload[DATA] || null;
  payload[ERROR] = payload[ERROR] || null;
  if (ws.readyState === ws.OPEN) {
    ws.send(JSON.stringify(payload))
  } else {
    console.log('[DEBUG] WS NOT OPEN')
  }
}

class SpeechClient {

  ws;
  speechClientConnected;
  speechServerStarted;
  sessionId;
  accessToken;
  transcriptionLanguage;
  translationLanguage;

  setAccessToken = t => this.accessToken = t;
  setTranscriptionLanguage = l => this.transcriptionLanguage = l;
  setTranslationLanguage = l => this.translationLanguage = l;


  connect = (onOpen, onClose, onData, onStatus, onError) => {
    this.ws = new WebSocket(SPEECH_SERVER_URI);

    this.ws.onopen = () => {
      this.speechClientConnected = true;
      console.log('ws open.');
      onOpen();
    };

    this.ws.onclose = () => {
      this.speechClientConnected = false;
      console.log('ws closed.');
      onClose();
    };

    this.ws.onmessage = (message) => {

      if (!message.data) return;
      const payload = JSON.parse(message.data);

      if (payload[SESSION_ID]) this.sessionId = payload[SESSION_ID];
      if (payload[ERROR]) onError(payload[ERROR]);
      if (payload[DATA]) onData(payload[DATA]);
      if (payload[STATUS]) {
        if (payload[STATUS] === STARTED) this.speechServerStarted = true;
        if (payload[STATUS] === STOPPED) this.speechServerStarted = false;
        onStatus(this.speechServerStarted);
      }
    };
  };

  _send = (command, data) => {
    if (!this.speechClientConnected) return;

    const payload = {};
    if (!this.sessionId) {
      console.log('[DEBUG] NO SESSION ID');
      return;
    }

    payload[SESSION_ID] = this.sessionId;
    payload[COMMAND] = command;
    payload[DATA] = data;
    payload[ACCESS_TOKEN] = this.accessToken;
    payload[LANGUAGES] = {
      transcription: this.transcriptionLanguage,
      translation: this.translationLanguage
    };
    send(this.ws, payload);
    if (command) console.log('Speech client sent: ' + command);
  };

  send = data => this._send(null, data);

  start = () => this._send(START, null);

  stop = () => this._send(STOP, null);

  restart = () => this._send(RESTART, null);
}

export default new SpeechClient();



// WEBPACK FOOTER //
// ./src/containers/Subtitles/speechClient.js